import { createSlice } from "@reduxjs/toolkit";
import {
  fetchAviationForm,
  fetchAviationFormStep,
  searchApplications,
  updateAviationFormStep,
  updateCustomerCode,
} from "./applicationsSearchThunks";

const initialState = {
  isLoading: false,
  data: [],
  viewApplication: {
    isLoading: false,
    data: [],
  },
  editApplication: {
    isLoading: false,
    isSaving: false,
    data: [],
  },
};

export const applicationsSearch = createSlice({
  name: "applicationsSearch",
  initialState,
  reducers: {
    clearApplicationsSearch: {
      reducer(state) {
        state.isLoading = false;
        state.data = [];
      },
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(searchApplications.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(searchApplications.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        if (payload.data.success === true) {
          state.data = payload.data.content;
        } else {
          state.data = [];
        }
      })
      .addCase(searchApplications.rejected, (state) => {
        state.isLoading = false;
        state.data = [];
      })
      .addCase(fetchAviationForm.pending, (state) => {
        state.viewApplication.isLoading = true;
      })
      .addCase(fetchAviationForm.fulfilled, (state, { payload }) => {
        state.viewApplication.isLoading = false;
        state.viewApplication.data = payload.content;
      })
      .addCase(fetchAviationForm.rejected, (state) => {
        state.viewApplication.isLoading = false;
        state.viewApplication.data = null;
      })
      .addCase(updateCustomerCode.fulfilled, (state, { payload }) => {
        state.viewApplication.data.customer_code =
          payload.content.customer_code;
      })
      .addCase(fetchAviationFormStep.pending, (state) => {
        state.editApplication.isLoading = true;
      })
      .addCase(fetchAviationFormStep.fulfilled, (state, { payload }) => {
        state.editApplication.isLoading = false;
        state.editApplication.data = payload.content;
      })
      .addCase(fetchAviationFormStep.rejected, (state) => {
        state.editApplication.isLoading = false;
        state.editApplication.data = null;
      })
      .addCase(updateAviationFormStep.pending, (state) => {
        state.editApplication.isSaving = true;
      })
      .addCase(updateAviationFormStep.fulfilled, (state, { payload }) => {
        state.editApplication.isSaving = false;
        state.editApplication.data = payload.content;
      })
      .addCase(updateAviationFormStep.rejected, (state) => {
        state.editApplication.isSaving = false;
      });
  },
});

export const { clearApplicationsSearch } = applicationsSearch.actions;

export default applicationsSearch.reducer;
